import { Livewire, Alpine } from '../../../../../../../../vendor/livewire/livewire/dist/livewire.esm';
import Clipboard from '@ryangjchandler/alpine-clipboard'

Alpine.plugin(Clipboard)
Livewire.start()

// Swiper
import {Swiper, Navigation, Pagination, Thumbs} from 'swiper';
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
window.Swiper = Swiper

import './utils/accordion';
import './utils/modal';
import './utils/fullscreen-sidebar'
//import './utils/nav-scroll'

// Lazyload
import lazyLoadInit from '../../../../general/js/lazy';
lazyLoadInit();

// Swal
import Swal from 'sweetalert2';
window.Swal = Swal;
window.Toast = Swal.mixin({
    toast: true,
    position: 'top-right',
    iconColor: 'white',
    customClass: {
        popup: 'colored-toast'
    },
    showConfirmButton: false,
    timer: 3330,
    timerProgressBar: true
});


// Players
// require('soundmanager2/script/soundmanager2');


import Player from './utils/player'


// // LightGallery
// import lightGallery from 'lightgallery';
// import lgThumbnail from 'lightgallery/plugins/thumbnail';
// import lgZoom from 'lightgallery/plugins/zoom';
// import 'lightgallery/css/lightgallery-bundle.css';

// LightBox
import SimpleLightbox from "simplelightbox";
import 'simplelightbox/dist/simple-lightbox.min.css';

var lightbox = new SimpleLightbox('.gallery-lightbox a', {
    rtl: true,
    overlayOpacity: .8,
});
window.lightbox = lightbox;

// fslightbox
import FsLightbox from "fslightbox";

// Fancybox
import { Fancybox } from "@fancyapps/ui";
import "@fancyapps/ui/dist/fancybox/fancybox.css";

// Lazyload
import lazySizes from 'lazysizes';

const setupApp = ()=>
{
    lazySizes.init();
    // lightbox.refresh();
    refreshFsLightbox();

    // Fancybox
    Fancybox.bind("[data-fancybox]", {
        // Your custom options
    });

    // lightGallery(document.getElementById('products-light-gallery'), {
    //     plugins: [lgThumbnail, lgZoom],
    //     thumbnail: true,
    //     speed: 500,
    // });
    //
    // lightGallery(document.getElementById('gallery-light-gallery'), {
    //     plugins: [lgThumbnail, lgZoom],
    //     thumbnail: true,
    //     speed: 500,
    // });

    const tracksSwiper = new Swiper('.tracks-swiper-container', {
        direction: 'horizontal',
        slidesPerView: 1.2,
        freeMode:true,
        clickable: true,
        slidesOffsetAfter:120,
        breakpoints: {
            768:{
                slidesPerView: 2.2,
            },
            1024:{
                slidesPerView:1.8,
            },
            1280:{
                slidesPerView:3.1,
            },
            1920:{
                slidesPerView:4.4,
            },
        }
    });

    const shopSwiper = new Swiper('.shop-swiper-container', {
        direction: 'horizontal',
        slidesPerView: 1.2,
        freeMode:true,
        clickable: true,
        slidesOffsetAfter:120,
        breakpoints: {
            768:{
                slidesPerView: 2.2,
            },
            1280:{
                slidesPerView:3.3,
            },
            1920:{
                slidesPerView:4.4,
            },
        }

    });

    const videosSwiper = new Swiper('.videos-swiper-container', {
        direction: 'horizontal',
        slidesPerView: 1.2,
        freeMode:true,
        clickable: true,
        slidesOffsetAfter:120,
        breakpoints: {
            768:{
                slidesPerView: 2.2,
            },
            1280:{
                slidesPerView:2.1,
            },
            1920:{
                slidesPerView:3.2,
            },
        }

    });

    const albumsSwiper = new Swiper('.albums-swiper-container', {
        direction: 'horizontal',
        slidesPerView: 1.2,
        freeMode:true,
        clickable: true,
        slidesOffsetAfter:120,
        breakpoints: {
            768:{
                slidesPerView: 2.2,
            },
            1280:{
                slidesPerView:3.3,
            },
        }

    });

    const blogSwiper = new Swiper('.blog-swiper-container', {
        direction: 'horizontal',
        slidesPerView: 1.08,
        clickable:true,
        breakpoints:{
            768:{
                slidesPerView: 1.7,
            },
            1289:{
                slidesPerView:3.7,
            },
        }
    });


    const productGalleryThumb = new Swiper('.product-thumb-imgs-swiper-container', {
        modules: [Navigation],
        direction: 'horizontal',
        spaceBetween: 10,
        slidesPerView: 3,
        breakpoints: {
            768:{
                slidesPerView: 4,
            },
        },
        freeMode: true,
        watchSlidesVisibility: true,
        watchSlidesProgress: true,
    });

    const productGallery = new Swiper('.product-imgs-swiper-container', {
        modules: [Navigation, Thumbs],
        direction: 'horizontal',
        centeredSlides:true,
        centeredSlidesBounds:true,
        slidesPerView:1,
        navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev',
        },
        spaceBetween: 10,
        thumbs: {
            swiper : productGalleryThumb
        },
    });

    const blogHeroSwiper = new Swiper('.blog-hero-swiper-container', {
        direction: 'horizontal',
        slidesPerView: 1.05,
        spaceBetween: 10,
        freeMode:true,
        clickable: "true",
        slidesOffsetAfter:20,
        breakpoints: {
            768:{
                slidesPerView: 1.6,
            },
            1024: {
                slidesPerView: 2.3
            },
            1280:{
                enabled: false,
                slidesPerView:'auto',
            },
        }

    });

    const shopHeroSwiper = new Swiper('.shop-hero-swiper-container', {
        direction: 'horizontal',
        slidesPerView: 1.05,
        spaceBetween: 10,
        freeMode:true,
        clickable: "true",
        slidesOffsetAfter: 20,
        pagination: {
            el: '.swiper-pagination',
            type: 'bullets',
        },
        breakpoints: {
            768:{
                slidesPerView: 1.6,
            },
            1024: {
                slidesPerView: 2.3
            },
            1280:{
                slidesPerView:1,
            },
        }

    });

    const productRelatedItems = new Swiper('.product-related-items',  {
        slidesPerView: 1.2,
        spaceBetween: 15,
        breakpoints:{
            768:{
                slidesPerView: 2.3,
            },
            1024: {
                slidesPerView:3.3,
            },
            1280:{
                slidesPerView:4.3,
            },
        }
    });
}

["livewire:initialized", "livewire:navigated", "resize", "pageChanged"].forEach((event) => {
    window.addEventListener(event, setupApp)
})

window.addEventListener("livewire:navigated", function(){
    window.scrollTo({top: 0, behavior: 'smooth'});
})

// Vue
// window.Vue = require('vue');
// window.Vue = require('vue').default;
// import Vue from 'vue'
// import 'livewire-vue'
// window.Vue = Vue
// import Vuex from 'vuex'

// Vue.config.productionTip = false;
// Vue.config.devtools = false;

// Vue.use(Vuex)
//
// const vueStore = new Vuex.Store({
//     state: {
//         playing: false,
//         track: null,
//         action_play: false,
//         action_pause: false,
//     },
//     mutations: {
//         SET_TRACK(state, track) {
//             state.track = track;
//         },
//         SET_PLAYING(state, playing) {
//             state.playing = playing;
//         },
//         SET_ACTION_PLAY(state, action) {
//             state.action_play = action;
//         },
//         SET_ACTION_PAUSE(state, action) {
//             state.action_pause = action;
//         }
//     },
//     getters: {
//         track(state) {
//             return state.track;
//         },
//         isPlaying(state) {
//             return state.playing;
//         },
//     }
// })

// import ComponentAudioPlayer from './components/AudioPlayerComponent.vue'

// Vue.component('player-component', require('./components/PlayerComponent.vue').default);

// const app = new Vue({
//     el: '#app',
    // components: {
    //     'audio-player': ComponentAudioPlayer
    // }
// });


// console.clear();















//
// function getThemeFromLocalStorage() {
//     // if user already changed the theme, use it
//     if (window.localStorage.getItem('dark')) {
//         return JSON.parse(window.localStorage.getItem('dark'))
//     }
//
//     // else return their preferences
//     return (
//         !!window.matchMedia &&
//         window.matchMedia('(prefers-color-scheme: dark)').matches
//     )
// }
//
// function setThemeToLocalStorage(value) {
//     window.localStorage.setItem('dark', value)
// }
//
// function getMenuFromLocalStorage(key) {
//     if (window.localStorage.getItem(key)) {
//         return JSON.parse(window.localStorage.getItem(key))
//     }
//     return false;
// }
//
// function setMenuToLocalStorage(key, value) {
//     window.localStorage.setItem(key, value)
// }
//
//
// // console.log(window.sm2);
//
//
// window.Alpine.data('data', () => ({
//
//     dark: getThemeFromLocalStorage(),
//     logout() {
//         window.Swal.fire({
//             title: 'آیا مطمئنید؟',
//             text: "پس از خروج حساب کاربری می بایست برای مراجعه دفعه بعد مجددا وارد شوید",
//             icon: 'warning',
//             showCancelButton: true,
//             cancelButtonText: 'لغو',
//             confirmButtonText: 'بله خارج میشم',
//             customClass: {
//                 confirmButton: 'btn btn-primary',
//                 cancelButton: 'btn btn-red'
//             },
//         }).then((result) => {
//             if (result.isConfirmed) {
//                 window.document.location.href = HOME_URL + '/dashboard/logout';
//             }
//         });
//     },
//     toggleTheme() {
//         this.dark = !this.dark
//         setThemeToLocalStorage(this.dark)
//     },
//     isSideMenuOpen: false,
//     toggleSideMenu() {
//         this.isSideMenuOpen = !this.isSideMenuOpen
//     },
//     closeSideMenu() {
//         this.isSideMenuOpen = false
//     },
//
//     isPagesMenuOpen: false,
//     togglePagesMenu() {
//         this.isPagesMenuOpen = !this.isPagesMenuOpen
//     },
//
//     cartOpen: false,
//     closeCart() {
//         this.cartOpen = false
//     },
//
//     openModal: false,
//     toggleModal() {
//         this.openModal = ! this.openModal
//         if(this.openModal){
//
//             document.querySelector('body').style.overflow = 'hidden';
//             document.querySelector('body').style.pointerEvents = 'none';
//
//         }else {
//             document.querySelector('body').style.overflow = 'auto';
//             document.querySelector('body').style.pointerEvents = 'auto';
//         }
//     },
//
//     // FullScreen Sidebar
//     openFullscreenSidebar: false,
//     toggleFullscreenSidebar() {
//         this.openFullscreenSidebar = ! this.openFullscreenSidebar ;
//
//         if(this.openFullscreenSidebar){
//
//             document.querySelector('body').style.overflow = 'hidden';
//             document.querySelector('body').style.position =  'fixed';
//
//         }else {
//
//             document.querySelector('body').style.overflow = 'auto';
//             document.querySelector('body').style.position = 'relative';
//
//         }
//     },
//
//     // Sidebar
//     isCoworkingMenuOpen: getMenuFromLocalStorage('coworking'),
//     toggleCoworkingMenu() {
//         this.isCoworkingMenuOpen = !this.isCoworkingMenuOpen
//         setMenuToLocalStorage('coworking', this.isCoworkingMenuOpen);
//     },
//     isFinancialMenuOpen: getMenuFromLocalStorage('financial'),
//     toggleFinancialMenu() {
//         this.isFinancialMenuOpen = !this.isFinancialMenuOpen
//         setMenuToLocalStorage('financial', this.isFinancialMenuOpen);
//     },
//     isServicesMenuOpen: getMenuFromLocalStorage('services'),
//     toggleServicesMenu() {
//         this.isServicesMenuOpen = !this.isServicesMenuOpen
//         setMenuToLocalStorage('services', this.isServicesMenuOpen)
//     },
//
//     init() {
//         window.Alpine.store('profileMenu', {
//             show: false,
//             toggle(){
//                 this.show = !this.show;
//             },
//             open(){
//                 this.show = true;
//             },
//             close(){
//                 this.show = false;
//             }
//         });
//
//         window.Alpine.store('notificationsMenu', {
//             show: false,
//             toggle(){
//                 this.show = !this.show;
//             },
//             open(){
//                 this.show = true;
//             },
//             close(){
//                 this.show = false;
//             }
//         });
//
//
//     }
// }));
//
